import NewsDetailPage from './NewsDetailPage';

export default NewsDetailPage;
